import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { UUID } from '../../../types/shared/UUID';
import { useHasPermissions } from '../../accessControl/hooks/useHasPermissions';
import { CardTW } from '../../../tailwindComponents/CardTW/CardTW';
import cx from 'classnames';
import { clientUrls } from '../../../ui-toolkit/rest/ClientUrlFactory';
import { SubNavigationTW } from '../../../tailwindComponents/navigation/SubNavigationTW';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import type { FCWithChildren } from '../../../types/FCWithChildren';

export const CommentsNavigation: FCWithChildren = ({ children }) => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const { pathname } = useLocation();
  const isInternalReader = useHasPermissions([ePermissions.CommentsRead]);
  const isExternalReader = useHasPermissions([ePermissions.CommentsRead]);
  return (
    <CardTW>
      <SubNavigationTW>
        <Link
          className={cx('p-3 text-center decoration-1', {
            'border-b-2 border-b-black': pathname.endsWith('internal'),
          })}
          to={clientUrls.urlFor.adminCommentsInternal(orderId)}
          hidden={!isInternalReader}
        >
          Internal Comments
        </Link>
        <Link
          className={cx('p-3 text-center decoration-1', {
            'border-b-2 border-b-black': pathname.endsWith('external'),
          })}
          to={clientUrls.urlFor.adminCommentsExternal(orderId)}
          hidden={!isExternalReader}
        >
          Client Comments
        </Link>
        <Link
          className={cx('p-3 text-center decoration-1', {
            'border-b-2 border-b-black': pathname.endsWith('vendor'),
          })}
          to={clientUrls.urlFor.adminCommentsVendor(orderId)}
        >
          Vendor Comments
        </Link>
      </SubNavigationTW>
      {children}
    </CardTW>
  );
};
